"use client";

import { c as _c } from "react/compiler-runtime";
import { useRoomListing } from "@/components/modules/listings/api/queries/useRoomListing";
export function useAssociatePhotosStep(listingId) {
  const $ = _c(6);
  const t0 = listingId ?? "";
  let t1;
  if ($[0] !== t0) {
    t1 = {
      listingId: t0
    };
    $[0] = t0;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const {
    data
  } = useRoomListing(t1);
  let t2;
  if ($[2] !== data?.data?.pictures) {
    t2 = data?.data?.pictures ?? [];
    $[2] = data?.data?.pictures;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  const existingPictures = t2 as string[];
  let t3;
  if ($[4] !== existingPictures) {
    t3 = {
      existingPictures
    };
    $[4] = existingPictures;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  return t3;
}